(() => {
  angular
    .module('app.core')
    .factory('CountriesService', countriesService);

  countriesService.$inject = ['$resource'];

  function countriesService($resource) {
    var countriesService = {};
    var countriesResource = $resource('/country/:action/:isoCode');

    countriesService.getSupported = function () {
      return countriesResource.get({
        action: 'query'
      }).$promise;
    };

    countriesService.getOne = function (isoCode) {
      return countriesResource.get({
        action: 'get',
        isoCode: isoCode
      }).$promise;
    };

    /**
     * When a user selects a target group in the "Edit Campaign" interface, they
     * choose a RANGE of incomes, like 20k - 75k (a selection of option 2, 3 and 4)
     *
     * HOWEVER, this is not how the target_group income criterion works in the backend.
     * When we store income=[2,3,4], that means the panelist has answered one of the
     * income brackets (20-40), (40-75), or (75-100). Meaning their income is between
     * 20k and 100k.
     *
     * This function transforms an income criterion to the corresponding 'range' array,
     * so [2,3] becomes [2,3,4]
     */
    countriesService.incomeCriterionToRange = function(incomeCriterion){
      // Clone the original array
      var range = [];
      if (!incomeCriterion) {
        return range;
      }

      for(var i = 0; i < incomeCriterion.length; i++) {
        range.push(incomeCriterion[i]);
      }
      // Add the next number to 'close' the range
      var upperBound = incomeCriterion[incomeCriterion.length-1];
      range.push(upperBound+1);
      // Return the resulting array
      return range;
    };

    /**
     * This function transforms a 'range' array to the corresponding income criterion,
     * so [2,3,4] becomes [2,3]
     */
    countriesService.rangeToIncomeCriterion = function(range){
      // Clone the original array, stopping short of the last element
      var incomeCriterion = [];
      for(var i=0; i<range.length-1; i++) {
        incomeCriterion.push(range[i]);
      }
      // Return the resulting array
      return incomeCriterion;
    };

    return countriesService;
  }
})();
